/**
 * Post 도메인 배럴
 * @description 웹의 글 상세(`/blog/[slug]`)가 쓰는 만큼만. 서버 계약은 `BlogDto` 가 옮긴다.
 */
export type {
  BlogAuthor,
  BlogCategory,
  BlogDetail,
  BlogItem,
  BlogListResponse,
} from "./dtos";
export type {
  GetPostResponse,
  PostAuthor,
  PostDetail,
  PostTopic,
} from "./dtos";
export {
  POST_ARTICLE_ID,
  PostDetailAnalytics,
  PostDetailBody,
  PostDetailHeaderActions,
  PostDetailRelated,
} from "./components/detail";
export {
  getBlogDetail,
  getBlogItems,
  getRelatedPosts,
} from "./repositories/postApiRepository";
export { loadBlogItems } from "./actions/loadBlogItems";
export { formatPostDate } from "./utils/formatPostDate";
export { readingMinutes } from "./utils/readingTime";
